import DBO_FWC from '@op/hooks/useFrontWebConfig';
import {
  FeedsColumnsFuncResultType,
  MonitorSourceItemType,
  AccountCategoryType,
  MonitoringSourceResultType,
} from '../types';
import { accountKeyTitleList, SPECIAL_ACCOUNT_KEY } from '../../FilterCommon/widgets/MonitorSelect/config';

export default function getBaseColumns(
  keys: string[],
  columns: { [key: string]: any },
) {
  return keys
    .filter(item => !!columns[item])
    .map(item => {
      return columns[item];
    });
}

export function getColumnsAndSortColumns(
  keys: string[],
  columns: FeedsColumnsFuncResultType,
) {
  const list = keys
    .filter(item => !!columns[item])
    .map(item => {
      return columns[item];
    });

  const selectSortKeys: Array<string> = [];
  const sortColumns: Array<string> = [];

  list.forEach(item => {
    const { key, sortKey, tableSort } = item;

    if (sortKey) {
      selectSortKeys.push(sortKey);
    }

    if (tableSort) {
      sortColumns.push(key);
      if (!sortKey) {
        selectSortKeys.push(key);
      }
    }
  });

  return {
    columns: list,
    sortColumns,
    selectSortKeys,
  };
}

const commonGameStoreTextMap: any = {
  steam: 'Customer Reviews',
  opencritic: 'Critic Reviews',
};
const metacriticTextMap: any = {
  user_review: 'Customer Reviews',
  critic_review: 'Critic Reviews',
};

export function getMonitorSource(item: any) {
  const { name, type, source } = item;
  if (source === 'keyword') {
    return name;
  }

  if (!['steam', 'opencritic'].includes(name)) {
    return metacriticTextMap[type];
  }

  return commonGameStoreTextMap[name];
}

export function getMonitoringSource(
  monitor_source: MonitorSourceItemType[],
): MonitoringSourceResultType {
  const keyword: MonitorSourceItemType[] = [];
  const external: MonitorSourceItemType[] = [];
  const accountMap: Map<string, AccountCategoryType> = new Map();

  // 初始化所有账号分类
  accountKeyTitleList.forEach(item => {
    if (!item.isKeyword && !item.isExternal) {
      accountMap.set(item.key, {
        key: item.key,
        list: [],
        textInfo: item.textInfo,
      });
    }
  });

  if (Array.isArray(monitor_source)) {
    const externalList = DBO_FWC.get('external_data_sources');

    monitor_source.forEach(item => {
      // 关键词
      if (item.source === 'keyword') {
        keyword.push({ ...item, key: 'keyword' });
        return;
      }

      // 外部数据源
      if (externalList.includes(item.source)) {
        external.push({ ...item, key: 'external' });
        return;
      }

      // 账号按 category 分类
      const category = item.category || SPECIAL_ACCOUNT_KEY.DEFAULT;
      const categoryGroup = accountMap.get(category);
      if (categoryGroup) {
        categoryGroup.list.push({ ...item, key: 'account' });
      } else {
        // 未匹配的分类放入默认组
        const defaultGroup = accountMap.get(SPECIAL_ACCOUNT_KEY.DEFAULT);
        defaultGroup?.list.push({ ...item, key: 'account' });
      }
    });
  }

  // 按 accountKeyTitleList 顺序构建分类列表
  const accountCategories = accountKeyTitleList
    .filter(item => !item.isKeyword && !item.isExternal)
    .map(item => accountMap.get(item.key))
    .filter(Boolean) as AccountCategoryType[];

  // 构建合并列表（按顺序）
  const list: MonitorSourceItemType[] = [
    ...keyword,
    ...accountCategories.flatMap(cat => cat.list),
    ...external,
  ];

  return {
    keyword,
    external,
    accountCategories,
    list,
  };
}
